export var MapServiceEvent = ['mapload', 'mapchange'];
//# sourceMappingURL=IMapService.js.map